import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (!user) {
    return <Navigate to="/login" replace />;
  }
  const isAdmin = user.id_role === "R01" || user.role?.id === "R01";
  if (!isAdmin) {
    return <Navigate to="/login" replace />;
  }
  return children;
}
